<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_user.add_user')">
    <template #content>
      <v-container class="add-user">
        <v-form v-model="isFormValid"
                ref="addUserForm">
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_user.serial_no')"
                            v-model="user.serial_no"
                            type="number"
                            min="1" max="9999"
                            clearable></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.email')"
                            v-model="user.email"
                            clearable
                            :rules="emailRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.mobile')"
                            v-model="user.mobile"
                            clearable></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select outlined
                        :label="$t('register.salutation')"
                        :items="salutationOptions"
                        v-model="user.salutation"
                        :rules="requiredRules"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.surname_en')"
                            v-model="user.surname_en"
                            :rules="requiredRules"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.given_name_en')"
                            v-model="user.given_name_en"
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.surname_zh')"
                            v-model="user.surname_zh"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.given_name_zh')"
                            v-model="user.given_name_zh"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select outlined
                        :label="$t('register.company')"
                        :items="companyOptions"
                        v-model="user.company_id"
                        :rules="requiredRules"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.password')"
                            v-model="password"
                            :rules="passwordRules"
                            type="password"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.confirm_password')"
                            v-model="confirmPassword"
                            :rules="confirmPasswordRules"
                            type="password"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-radio-group v-model="user.id_type"
                             column
                             :rules="requiredRules">
                <v-radio :value="2" :label="$t('id_type.airport_octopus')"></v-radio>
                <v-radio :value="-1" :label="$t('id_type.VIP')"></v-radio>
                <!--                <v-radio :value="4" :label="$t('id_type.personal_octopus')"></v-radio>-->
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" lg="6">
              <v-text-field outlined
                            :label="$t('id_verification.suffix_number')"
                            placeholder="123456789"
                            v-model="user.id_no"
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="user.id_type !== -1">
            <v-col cols="12" lg="6">
              <v-row>
                <v-col class="pb-0">
                  {{ $t('register.octopus_front') }}
                </v-col>
              </v-row>
              <PhotoPreviewInput v-model="octopusFront"
                                 div-class="octopus-front"
                                 file-name="octopus-front"></PhotoPreviewInput>
            </v-col>
            <v-col cols="12" lg="6">
              <v-row>
                <v-col class="pb-0">
                  {{ $t('register.octopus_back') }}
                </v-col>
              </v-row>
              <PhotoPreviewInput v-model="octopusBack"
                                 div-class="octopus-back"
                                 file-name="octopus-back"></PhotoPreviewInput>
            </v-col>
          </v-row>

          <v-row v-if="user.id_type === 4">
            <v-col cols="12" lg="6">
              <v-row>
                <v-col class="pb-0">
                  {{ $t('register.id_front') }}
                </v-col>
              </v-row>
              <PhotoPreviewInput v-model="idFront"
                                 div-class="id-front"
                                 file-name="id-front"></PhotoPreviewInput>
            </v-col>
            <v-col cols="12" lg="6">
              <v-row>
                <v-col class="pb-0">
                  {{ $t('register.id_back') }}
                </v-col>
              </v-row>
              <PhotoPreviewInput v-model="idBack"
                                 div-class="id-back"
                                 file-name="id-back"></PhotoPreviewInput>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.addUserForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import {computed, ref, watch} from '@vue/composition-api';
import BGModal from "@/components/BGModal";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'AddMemberModal',
  components: {PhotoPreviewInput, BGModal},
  props: {
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          user.value = {};
          password.value = null;
          confirmPassword.value = null;
          getCompanies();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const addUserForm = ref(null);
    const isFormValid = ref(false);

    const user = ref({});

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const emailRules = ref([
      value => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || root.$t('register.invalid_email'),
    ]);

    const salutationOptions = ref([
      {value: 'mr', text: root.$t('salutation.mr')},
      {value: 'mrs', text: root.$t('salutation.mrs')},
      {value: 'ms', text: root.$t('salutation.ms')},
      {value: 'dr', text: root.$t('salutation.dr')},
    ]);

    const companies = ref([]);
    const getCompanies = function () {
      root.$callAPI('hkiarace/admin/company/', {
        page_size: -1
      }, function (response) {
        companies.value = response.body.companies;
      });
    };
    const companyOptions = computed(() => {
      return companies.value.map((c) => {
        return {text: c.name, value: c.id};
      })
    });

    const password = ref(null);
    const passwordRules = ref([
      value => (!!value && value.length >= 8) || root.$t('register.password_contain_eight_characters'),
      value => (!!value && !!value.match(/[A-Za-z]/g)) || root.$t('register.password_contain_letters'),
      value => (!!value && !!value.match(/[0-9]/g)) || root.$t('register.password_contain_numbers'),
      value => (!!value && !!value.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !value.match(/[ ]/g)) || root.$t('register.password_contain_special_characters'),
    ]);
    const confirmPassword = ref(null);
    const confirmPasswordRules = ref([
      value => (!!value && value === password.value) || root.$t('register.password_match'),
    ]);

    const octopusFront = ref(null);
    const octopusBack = ref(null);
    const idFront = ref(null);
    const idBack = ref(null);

    const save = async function () {
      if (user.value.id_type !== -1 && !octopusFront.value) {
        root.$vuetify.goTo('.octopus-front', {easing: 'easeInOutCubic', offset: 250});
        return
      }

      if (user.value.id_type !== -1 && !octopusBack.value) {
        root.$vuetify.goTo('.octopus-back', {easing: 'easeInOutCubic', offset: 250});
        return
      }

      if (user.value.id_type === 4 && !idFront.value) {
        root.$vuetify.goTo('.id-front', {easing: 'easeInOutCubic', offset: 250});
        return
      }

      if (user.value.id_type === 4 && !idBack.value) {
        root.$vuetify.goTo('.id-back', {easing: 'easeInOutCubic', offset: 250});
        return
      }

      let params = {
        ...user.value,
        password: password.value,
        octopus_front: user.value.id_type !== -1 ? await root.$convertFileToBase64(octopusFront.value) : null,
        octopus_back: user.value.id_type !== -1 ? await root.$convertFileToBase64(octopusBack.value) : null,
        id_front: user.value.id_type === 4 ? await root.$convertFileToBase64(idFront.value) : null,
        id_back: user.value.id_type === 4 ? await root.$convertFileToBase64(idBack.value) : null,
      };

      root.$callAPI('hkiarace/admin/user/create/', params, (response) => {
        emit('finish', response.body.user);
      });
    }

    return {
      dialogShown,
      cancel,

      addUserForm,
      isFormValid,
      user,

      requiredRules,
      emailRules,
      salutationOptions,
      companyOptions,

      password,
      passwordRules,
      confirmPassword,
      confirmPasswordRules,

      octopusFront,
      octopusBack,
      idFront,
      idBack,

      save,
    }
  },
}
</script>

<style lang="less">
.add-user {
  .photo-preview-input-div {
    &::before {
      content: "";
      opacity: 0.15;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
    }

    &.id-front::before {
      background: url('../../assets/ara-front.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.octopus-front::before {
      background: url('../../assets/octopus-front.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.id-back::before {
      background: url('../../assets/ara-back.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.octopus-back::before {
      background: url('../../assets/octopus-back.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
</style>
